export const tokens = {
    card: {
        padding: {
            base: 16,
            large: 28,
        },
        size: {
            base: 280,
            large: 426,
        },
    },
    title: {
        fontSize: {
            base: 30,
            large: 48,
        },
    },
    itemValue: {
        fontSize: {
            base: 24,
            large: 36,
        },
    },
    itemLabel: {
        fontSize: {
            base: 12,
            large: 18,
        },
    },
};
